import React from "react";
import { LexiconProvider } from "./src/context/LexiconContext";

export default function wrapRootElement({ element }) {
  return <LexiconProvider>{element}</LexiconProvider>;
}
